import type { TranslationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core-react/i18n';

import {
	MAX_IMAGE_COUNT,
	MAX_IMAGE_ERROR_TEXT,
	MAX_VIDEO_COUNT,
	MAX_VIDEO_ERROR_TEXT,
} from '../shared/config/constants';

export const useSetErrorMessage = (): ((errorKey: TranslationKey | null) => string | null) => {
	const { typedTranslate } = useI18n();

	const setErrorMessage = (errorKey: TranslationKey | null): string | null => {
		if (errorKey === null) return null;
		if (errorKey === MAX_IMAGE_ERROR_TEXT) return typedTranslate(errorKey, { count: MAX_IMAGE_COUNT });
		if (errorKey === MAX_VIDEO_ERROR_TEXT) return typedTranslate(errorKey, { count: MAX_VIDEO_COUNT });
		return typedTranslate(errorKey);
	};

	return setErrorMessage;
};
